"use strict";

class SuperManageDeveloperReportsController {

    constructor($scope, $parse, $timeout, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        self.categoryEditMode = false;
        self.errors = {
            category:''
        };
        self.addCategoryParams = {
            category:''
        };

        self.singleCategorySelectedMode = false;
        self.singleSelectedCategory = null;

        self.selectedDeveloperId = '';
        self.niceSelectInitialized = false;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        self.getDevelopers();
        self.getAllReports();
    }

    initNiceSelectAndOpen() {
        const self = this;
        self.$timeout(function () {
            const $select = $('#developer-select');
            if (!$select.length) return;

            if (self.niceSelectInitialized) {
                $select.niceSelect('update');
            } else {
                $select.niceSelect();
                self.niceSelectInitialized = true;
            }

            const $nice = $select.next('.nice-select');
            if ($nice.length && !$nice.hasClass('open')) {
                $nice.trigger('click');
            }
        }, 0);
    }

    onDeveloperSelectChange() {
        const self = this;
        const dev = (self.developers || []).find(function (d) {
            return String(d.id) === String(self.selectedDeveloperId);
        });
        if (dev) {
            self.developerSelectionChanged(dev);
        } else {
            self.selectedDeveloper = null;
            self.developerReports = null;
            self.developerReportCategories = null;
        }
    }

    getAllReports(){
        const self = this;

        self.reports = null;

        let url = 'sec/super/reports';
        let prams = {
            type: 10
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url,prams).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.reports = response.data.reports;
        });
    }

    getDevelopers() {
        const self = this;

        self.developers = null;

        let url = 'developers';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developers = response.data.developers;
            self.initNiceSelectAndOpen();
        });
    }

    getDeveloperReports(){
        const self = this;

        self.developerReports = null;
        self.developerReportCategories = null;

        let url = 'sec/super/developer-reports';
        let params = {
            developer_id : self.selectedDeveloper.id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developerReports = response.data.developer_reports;
            self.developerReportCategories = response.data.developer_report_categories;
            self.getDeveloperReportCategories();
        });
    }

    getDeveloperReportCategories(){
        const self = this;

        let url = 'sec/super/developer-report-categories/';

        loading(true);
        self.SSHttpService.getAPIRequest(url,{developer_id:self.selectedDeveloper.id}).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            angular.merge(self.developerReportCategories,response.data.developer_report_categories);
        });

    }

    developerSelectionChanged(developer){
        const self = this;

        self.selectedDeveloper = developer;
        this.getDeveloperReports();
    }

    getDeveloperCategoryReportCount(developerReportCategory){
        const self = this;
        let count = 0;
        if(self.developerReports) {
            self.developerReports.forEach(function (report) {
                    report.developer_report_category_id === (developerReportCategory && developerReportCategory.id) ? count++ : null;
            });
        }
        return count;
    }

    onCategoryEdit(){
        const self = this;
        self.categoryEditMode = !self.categoryEditMode;
        self.developerReportCategoriesParams = angular.copy(self.developerReportCategories);
    }

    onSaveCategories(){
        const self = this;
        loading(true);
        if(self.developerReportCategoriesParams)
        self.developerReportCategoriesParams.forEach(function (value) {

            if(value.id !== 0) {
                let url = 'sec/super/developer-report-categories/' + value.id;

                value.developer_id = self.selectedDeveloper.id;

                self.SSHttpService.putAPIRequest(url, value).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                });
            }
        });
        self.categoryEditMode = !self.categoryEditMode;
        self.getDeveloperReports();
    }

    saveNewCategory(){
        const self = this;
        self.addCategoryParams.developer_id = self.selectedDeveloper.id;

        if(self.addCategoryParams.category === null || self.addCategoryParams.category === ''){
            self.errors.category = true;
            console.log(self.errors.category);
            return;
        }

        let url = 'sec/super/developer-report-categories/';
        loading(true);
        self.SSHttpService.postAPIRequest(url,self.addCategoryParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.getDeveloperReports();
            self.errors.category = false;
        });
        $('#addCategoryModal').modal('hide');
    }

    deleteCategory(developerReportCategoryParam){
        const self = this;
        self.selectedReportCategoryToDelete = developerReportCategoryParam;
        $('#deleteCategoryModal').modal('show');
    }

    _deleteCategory(){
        const self = this;

        let url = 'sec/super/developer-report-categories/'+self.selectedReportCategoryToDelete.id+'/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            $('#deleteCategoryModal').modal('hide');
            self.selectedReportCategoryToDelete = null;
            self.getDeveloperReports();
            self.categoryEditMode = false;
        });
    }

    singleCategoryClicked(developerReportCategory){
        const self = this;
        self.singleSelectedCategory = developerReportCategory;
        self.singleCategorySelectedMode = !!developerReportCategory;
        self.selectedCategoryReports = [];

        if(developerReportCategory) {
            self.reports.forEach(function (report) {
                let singleSelection = {};
                singleSelection['original_name'] = report.name + ' - ' + report.code;
                singleSelection['is_assigned'] = self.getAssignedCategoryReport(developerReportCategory, report);
                singleSelection['alias'] = self.getAssignedCategoryReportAlias(developerReportCategory, report);
                singleSelection['alias_new'] = singleSelection['alias'];
                singleSelection['developer_report_id'] = self.getAssignedCategoryReportId(developerReportCategory, report);
                singleSelection['report_id'] = report.id;
                singleSelection['category_id'] = developerReportCategory.id;
                singleSelection['developer_id'] = self.selectedDeveloper.id;
                singleSelection['request_sent'] = false;
                singleSelection['is_editable'] = false;
                self.selectedCategoryReports.push(singleSelection);
            });
        }
    }

    getAssignedCategoryReport(developerReportCategory, report){
        const self = this;
        let check = false;
        self.developerReports.forEach(function (developerReport) {
            if(developerReport.developer_report_category_id == developerReportCategory.id && developerReport.report_id == report.id)
                check = true;
        });
        return check;
    }

    getAssignedCategoryReportAlias(developerReportCategory, report){
        const self = this;
        let alias = null;
        self.developerReports.forEach(function (developerReport) {
            if(developerReport.developer_report_category_id == developerReportCategory.id && developerReport.report_id == report.id)
                alias = developerReport.alias;
        });
        return alias;
    }

    getAssignedCategoryReportId(developerReportCategory, report){
        const self = this;
        let developer_report_id = null;
        self.developerReports.forEach(function (developerReport) {
            if(developerReport.developer_report_category_id == developerReportCategory.id && developerReport.report_id == report.id)
                developer_report_id = developerReport.id;
        });
        return developer_report_id;
    }

    saveSingleCategoryAssignedReports(){
        const self = this;
        self.selectedCategoryReports.forEach(function (report){
            report.is_editable = false;
        });
        loading(true);
        self._saveSingleCategoryAssignedReport(self.selectedCategoryReports,0,self.selectedCategoryReports.length);
        loading(false);
        self.SSAlertService.success("Success!", "Report settings saved successfully");
        self.developerReportCategories = null;
        self.developerSelectionChanged(self.selectedDeveloper);
    }

    _saveSingleCategoryAssignedReport(selectedReports, index, length){
        const self = this;
        let url = '';
        if(index >= length) {
            return;
        }

        if(selectedReports[index].is_assigned){
            if(!selectedReports[index].developer_report_id && !selectedReports[index].request_sent) {
                url = 'sec/super/developer-reports';
                let param = {
                    developer_id: selectedReports[index].developer_id,
                    developer_report_category_id: selectedReports[index].category_id,
                    report_id: selectedReports[index].report_id,
                    alias: selectedReports[index].alias
                };
                selectedReports[index].request_sent = true;
                self.SSHttpService.postAPIRequest(url, param).then(function (response) {
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self._saveSingleCategoryAssignedReport(selectedReports,++index,length);
                });
            }
        }
        else{
            if(selectedReports[index].developer_report_id && !selectedReports[index].request_sent) {
                url = 'sec/super/developer-reports/' + selectedReports[index].developer_report_id + '/delete';
                selectedReports[index].request_sent = true;
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self._saveSingleCategoryAssignedReport(selectedReports,++index,length);
                });
            }
        }
        self._saveSingleCategoryAssignedReport(selectedReports,++index,length);
    }

    editSelectedCategoryReportAlias(selectedCategoryReport, check){
        const self = this;
        selectedCategoryReport.is_editable = check;
        if(!check){
            selectedCategoryReport.alias_new = selectedCategoryReport.alias;
        }
    }

    saveSelectedCategoryReportAlias(selectedCategoryReport){
        const self = this;

        let url = 'sec/super/developer-reports/'+selectedCategoryReport.developer_report_id;
        let param = {
            developer_id : selectedCategoryReport.developer_id,
            developer_report_category_id: selectedCategoryReport.category_id,
            report_id: selectedCategoryReport.report_id,
            alias: selectedCategoryReport.alias_new
        };
        loading(true);
        self.SSHttpService.putAPIRequest(url,param).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            selectedCategoryReport.alias = selectedCategoryReport.alias_new;
            self.editSelectedCategoryReportAlias(selectedCategoryReport,false);
        });
    }

    selectAllClicked(){
        const self = this;
        self.selectedCategoryReports.forEach(function (report) {
            report.is_assigned = !report.is_assigned;
        });
    }

    selectAllChecked(){
        const self = this;
        let check = true;
        if(!self.selectedCategoryReports)
            return;
        self.selectedCategoryReports.forEach(function (report) {
            if(report.is_assigned != true)
                check = false;
        });
        return check;
    }

}

SuperManageDeveloperReportsController.$inject = ['$scope', '$parse', '$timeout', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService'];
app.controller('SuperManageDeveloperReportsController', SuperManageDeveloperReportsController);

